import styled, { css } from 'styled-components'

type WrapperProps = {
  hasSecodaryButton: boolean
  hasblueButton: boolean
  hasredButton: boolean
}

export const Wrapper = styled.button<WrapperProps>`
  ${({ theme, hasSecodaryButton, hasblueButton, hasredButton }) => css`
    font-size: ${theme.font.sizes.xxsmall};
    font-weight: ${theme.font.bold};
    border: 1px solid ${theme.colors.white};
    background: ${theme.colors.primary};
    border-radius: ${theme.border.xradius};
    min-width: 3rem;
    color: ${theme.colors.white};
    padding: 0.8rem;
    width: 100%;
    cursor: pointer;
    transition: ${theme.transition.default};

    ${hasSecodaryButton &&
    css`
      background: ${theme.colors.mainBg};
      border: 1px solid ${theme.colors.xgray};
      color: ${theme.colors.darkGray};
    `}

    ${hasblueButton &&
    css`
      background: ${theme.colors.blue};
    `}

    ${hasredButton &&
    css`
      background: ${theme.colors.red};
    `}

    &:hover {
      outline: none;
      filter: brightness(0.9);
    }

    :disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `}
`
